// making sure the assests URLs will be resolved
// related to script origin
const scriptSrc = document.currentScript ? (document.currentScript as HTMLScriptElement).src : null;

if (scriptSrc) {
  const currentScript = new URL(scriptSrc);

  __webpack_public_path__ = `${currentScript.origin}/`;
}
